import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getAllNotifications } from 'actions/notifications';
import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Modal from 'components/NotificationsDrawer/NotificationDialog';
import WarningImage from 'assets/images/warning.png';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    height: 60,
    backgroundColor: theme.palette.background.default,
    justifyContent: 'center',
  },
  label: {
    fontFamily: 'Inter600',
    color: '#18191F',
    fontSize: 18,
  },
  img: {
    width: '100%',
  },
  warningImage: {
    marginRight: 10,
    width: 30,
  },
  notification: {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.5,
    },
  },
}));

const Stepper = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const [notifications, setNotifications] = useState(null);
  const [notification, setNotification] = useState(null);
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = notifications?.length ?? 0;

  const getNotificationsData = async () => {
    const data = await dispatch(getAllNotifications());
    setNotifications(() => data);
  };

  useEffect(() => {
    getNotificationsData();
  }, [dispatch]);

  useEffect(() => {
    if (!notifications?.length) return undefined;

    const timer = setInterval(() => {
      setActiveStep((prevActiveStep) =>
        prevActiveStep >= notifications.length - 1 ? 0 : prevActiveStep + 1
      );
    }, 7000);

    return () => clearInterval(timer);
  }, [notifications]);

  const handleNext = () =>
    setActiveStep((prevActiveStep) => prevActiveStep + 1);

  const handleBack = () =>
    setActiveStep((prevActiveStep) => prevActiveStep - 1);

  const activeNotification = notifications?.[activeStep];
  const imageSplit = activeNotification?.notification?.image?.split('/upload/');
  const activeImage = imageSplit
    ? `${imageSplit[0]}/upload/${imageSplit[1]}`
    : 'https://res.cloudinary.com/big-oven-tees-inc/image/upload/v1631199707/Shirtly/Web_Pages/LandingPage/Header/shirtly-premium-logo_sscytx_royuzk.png';

  return (
    <div
      style={{
        borderRadius: 10,
        boxShadow:
          '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
      }}
    >
      <Paper
        square
        elevation={0}
        className={classes.header}
        style={{ borderRadius: 10 }}
      >
        <img
          src={WarningImage}
          alt="WarningImage"
          className={classes.warningImage}
        />
        <Typography className={classes.label}>Shirtly Updates</Typography>
      </Paper>
      <div
        className={classes.notification}
        style={{
          backgroundImage: `url(${activeImage})`,
          height: 310,
          maxHeight: 310,
          overflow: 'hidden',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: '50% 50%',
        }}
        onClick={() => {
          setNotification(activeNotification);
        }}
      />
      <MobileStepper
        style={{ borderRadius: 10 }}
        steps={maxSteps}
        position="static"
        variant="progress"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
      <Modal
        open={!!notification}
        data={notification}
        setOpen={() => setNotification(null)}
      />
    </div>
  );
};

export default Stepper;
